import { useLanguage } from "@/contexts/LanguageContext";
import { Target, TrendingDown } from "lucide-react";

const SecretWeaponSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          




          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            {t.secretWeapon.title}
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            {t.secretWeapon.description}
          </p>

          <div className="bg-card border border-primary/20 rounded-2xl p-8 shadow-lg text-left" style={{ boxShadow: "0 0 40px -10px hsl(152 55% 28% / 0.1)" }}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mt-1">
                <TrendingDown className="h-6 w-6 text-accent" />
              </div>
              <p className="text-foreground leading-relaxed text-base md:text-lg">
                {t.secretWeapon.benefit}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default SecretWeaponSection;